export class HTML {

    /**
     * @param {string} name
     * @param {HTMLElement?} element
     * @return {string}
     */
    static cssVariable(name, element=null) {
        element = element ? element : document.body;
        if (!name.startsWith('--')) {
            name = '--'+name;
        }
        return getComputedStyle(element).getPropertyValue(name);
    }
}